__turbopack_context__.v({
  "addToCart": "productDetails-module-scss-module__vfLX7G__addToCart",
  "addToCartCases": "productDetails-module-scss-module__vfLX7G__addToCartCases",
  "addToCartWrapper": "productDetails-module-scss-module__vfLX7G__addToCartWrapper",
  "additionalFeatures": "productDetails-module-scss-module__vfLX7G__additionalFeatures",
  "code": "productDetails-module-scss-module__vfLX7G__code",
  "description": "productDetails-module-scss-module__vfLX7G__description",
  "details": "productDetails-module-scss-module__vfLX7G__details",
  "discount": "productDetails-module-scss-module__vfLX7G__discount",
  "divider": "productDetails-module-scss-module__vfLX7G__divider",
  "exclusiveText": "productDetails-module-scss-module__vfLX7G__exclusiveText",
  "extras": "productDetails-module-scss-module__vfLX7G__extras",
  "joinText": "productDetails-module-scss-module__vfLX7G__joinText",
  "keyClubExclusiveLabel": "productDetails-module-scss-module__vfLX7G__keyClubExclusiveLabel",
  "keyClubJoin": "productDetails-module-scss-module__vfLX7G__keyClubJoin",
  "keyclubJoin": "productDetails-module-scss-module__vfLX7G__keyclubJoin",
  "keyclubJoinFeldmans": "productDetails-module-scss-module__vfLX7G__keyclubJoinFeldmans",
  "meta": "productDetails-module-scss-module__vfLX7G__meta",
  "noShipIcon": "productDetails-module-scss-module__vfLX7G__noShipIcon",
  "nonShippableMessage": "productDetails-module-scss-module__vfLX7G__nonShippableMessage",
  "nonShippableText": "productDetails-module-scss-module__vfLX7G__nonShippableText",
  "props": "productDetails-module-scss-module__vfLX7G__props",
  "reviews": "productDetails-module-scss-module__vfLX7G__reviews",
  "shipButton": "productDetails-module-scss-module__vfLX7G__shipButton",
  "shipToMyDoor": "productDetails-module-scss-module__vfLX7G__shipToMyDoor",
  "size": "productDetails-module-scss-module__vfLX7G__size",
  "sku": "productDetails-module-scss-module__vfLX7G__sku",
  "stockStateWrapper": "productDetails-module-scss-module__vfLX7G__stockStateWrapper",
});
